import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AutoMeasureService } from '../auto-measure.service';

@Component({
    selector: 'app-auto-measure-loading',
    imports: [CommonModule],
    templateUrl: './auto-measure-loading.component.html',
    styleUrl: './auto-measure-loading.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoMeasureLoadingComponent {
    readonly #bsModalRef = inject(BsModalRef);
    readonly #autoMeasureService = inject(AutoMeasureService);

    interval?: number;
    isLoadingComplete: boolean = false;
    loadingStates = ['Processing plan', 'Identifying rooms', 'Calculating measurements'];

    currentStep = signal(0);
    $obs = toObservable(this.#autoMeasureService.autoMeasureInProgress).subscribe((val) => {
        if (!val) {
            this.isLoadingComplete = true;
            this.currentStep.set(this.loadingStates.length);
            // timeout to dismiss the modal gracefully
            setTimeout(() => {
                this.#bsModalRef.hide();
            }, 500);
        }
    });

    ngOnInit() {
        this.cycleLoadingStates();
    }

    cycleLoadingStates() {
        const intervalTime = 3000;
        let step = 0;

        if (this.interval) {
            clearInterval(this.interval);
        }

        this.interval = window.setInterval(() => {
            this.currentStep.set(step);
            step++;

            if (this.isLoadingComplete) {
                this.currentStep.set(this.loadingStates.length);
            }

            if (step >= this.loadingStates.length) {
                window.clearInterval(this.interval);
            }
        }, intervalTime);
    }

    stopGeneration() {
        this.#autoMeasureService.stopGeneration();
        this.#bsModalRef.hide();
    }

    ngOnDestroy(): void {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
    }
}
